import React from 'react';
import { Select, Input, Button, Tag, AutoComplete } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Card, FilterRow, TokenChip } from './styled';

const OPERATORS = [
  { value: 'equals', label: 'equals' },
  { value: 'not_equals', label: 'does not equal' },
  { value: 'contains', label: 'contains' },
  { value: 'exists', label: 'is provided' }
];

const StepTrigger = ({ automation, update, triggers }) => {
  const selected = triggers.find((t) => t.key === automation.triggerEvent);
  const filters = automation.triggerFilters || [];

  const fieldMeta = selected?.fields || [];
  const fieldOptions = (selected?.availableTokens || []).map((tok) => {
    const meta = fieldMeta.find((f) => f.key === tok);
    return { value: tok, label: meta ? `${meta.label} (${tok})` : tok };
  });
  const optionsFor = (fieldKey) => fieldMeta.find((f) => f.key === fieldKey)?.options || null;

  const updateFilter = (idx, patch) => {
    const next = [...filters];
    next[idx] = { ...next[idx], ...patch };
    update({ triggerFilters: next });
  };
  const addFilter = () => update({ triggerFilters: [...filters, { field: '', operator: 'equals', value: '' }] });
  const removeFilter = (idx) => update({ triggerFilters: filters.filter((_, i) => i !== idx) });

  return (
    <>
      <Card>
        <h3>Choose a trigger event</h3>
        <div className="desc">This automation will run every time the selected event happens.</div>
        <Select
          size="large"
          style={{ width: '100%' }}
          placeholder="Select an event…"
          value={automation.triggerEvent || undefined}
          onChange={(v) => update({ triggerEvent: v })}
          options={triggers.map((t) => ({
            value: t.key,
            label: `${t.label}  •  ${t.category}`
          }))}
        />
      </Card>

      {selected && (
        <Card>
          <h3>{selected.label}</h3>
          <div className="desc">{selected.description}</div>
          <label>Available data</label>
          <div>
            {(selected.availableTokens || []).map((tok) => (
              <TokenChip key={tok}>{`{{${tok}}}`}</TokenChip>
            ))}
          </div>
        </Card>
      )}

      {selected && (
        <Card>
          <h3>Filter conditions <Tag style={{ marginLeft: 8 }}>Optional</Tag></h3>
          <div className="desc">Only run this automation when the trigger payload matches every condition below.</div>
          {filters.map((f, idx) => {
            const valueOptions = optionsFor(f.field);
            return (
              <FilterRow key={idx}>
                <AutoComplete
                  placeholder="field (e.g. preferredCity)"
                  value={f.field}
                  options={fieldOptions}
                  filterOption={(input, opt) =>
                    (opt?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  onChange={(v) => updateFilter(idx, { field: v })}
                />
                <Select
                  value={f.operator}
                  onChange={(v) => updateFilter(idx, { operator: v })}
                  options={OPERATORS}
                />
                {f.operator === 'exists' ? (
                  <Input value="" disabled placeholder="—" />
                ) : valueOptions ? (
                  <Select
                    placeholder="value"
                    value={f.value || undefined}
                    onChange={(v) => updateFilter(idx, { value: v })}
                    options={valueOptions}
                  />
                ) : (
                  <Input
                    placeholder="value"
                    value={f.value}
                    onChange={(e) => updateFilter(idx, { value: e.target.value })}
                  />
                )}
                <Button danger type="text" icon={<DeleteOutlined />} onClick={() => removeFilter(idx)} />
              </FilterRow>
            );
          })}
          <Button icon={<PlusOutlined />} onClick={addFilter} style={{ marginTop: 8 }}>
            Add condition
          </Button>
        </Card>
      )}
    </>
  );
};

export default StepTrigger;
